import { useEffect } from 'react'
import { disableSupportChat, enableSupportChat } from './supportChatController'

export const useSupportChatPrintListeners = () => {
  useEffect(() => {
    globalThis.addEventListener('beforeprint', disableSupportChat)
    globalThis.addEventListener('afterprint', enableSupportChat)

    return () => {
      globalThis.removeEventListener('beforeprint', disableSupportChat)
      globalThis.removeEventListener('afterprint', enableSupportChat)
    }
  }, [])
}
